import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  defaultSort,
  highToLow,
  lowToHigh
} from "../../features/jobs/jobsSlice";

function SalarySortFilter() {
  const [salarySort, setSalarysort] = useState("default");
  const dispatch = useDispatch();
  const onChangeHandler = (e) => {
    if (e.target.value === "default") dispatch(defaultSort());
    else if (e.target.value === "lowToHigh") dispatch(lowToHigh());
    else if (e.target.value === "highToLow") dispatch(highToLow());
    setSalarysort(e.target.value);
  };
  return (
    <select
      id="lws-sort"
      name="sort"
      autoComplete="sort"
      className="flex-1"
      onChange={onChangeHandler}
    >
      <option value="default">Default</option>
      <option value="lowToHigh">Salary (Low to High)</option>
      <option value="highToLow">Salary (High to Low)</option>
    </select>
  );
}

export default SalarySortFilter;
